import React, { useState } from 'react';
import styles from './add-client.module.css';
import { MemberModal } from '../member-modal';
import { Button } from '../button';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useTranslation } from 'react-i18next';

type AddClientProps = {
  onClose: () => void;
};

export const AddClient: React.FC<AddClientProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { admin } = useSelector((state: RootState) => state.admin);
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>{t('clientOrganisation')}</h1>
      <Button onClick={() => setIsModalOpen(true)}>{t('addNewClient')}</Button>
      <MemberModal
        isOpen={isModalOpen}
        onClose={() => {
          onClose();
          setIsModalOpen(false);
        }}
        admin={admin}
      />
    </div>
  );
};
